import { useEffect, useRef } from 'react'

import { JourneyOutcome } from '@cash-web/protos/squareup/cash/blockuserjourneys/api/v1/service.pb'
import { TaxWebViewBlocker } from '@cash-web/protos/squareup/franklin/blockers/tax_web_view_blocker.pb'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { useUserJourneyContext } from '@cash-web/shared-user-journey-data-access-context'
import { USER_JOURNEY_NAMES } from '@cash-web/shared-user-journey-feature-main'

import { useTaxLoginSuccessEvent } from '../../util'
import { BlockerLoading } from '../BlockerLoading/BlockerLoading'

export const BlockerTaxWebViewBlocker = ({ blocker }: { blocker: TaxWebViewBlocker }) => {
  const taxLoginSuccessEvent = useTaxLoginSuccessEvent()
  const flow = useFlowContext()
  const navigating = useRef(false)
  const userJourneyContext = useUserJourneyContext()

  useEffect(() => {
    if (blocker?.url && !navigating.current) {
      navigating.current = true
      taxLoginSuccessEvent().then(() => {
        flow.complete()
        userJourneyContext.completeJourney(USER_JOURNEY_NAMES.TAXES_UPGRADE, JourneyOutcome.JOURNEY_OUTCOME_SUCCEEDED)
        window.open(blocker.url, '_self')
      })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!blocker?.url) {
    throw new Error('No valid url provided with tax terminal blocker.')
  }

  return <BlockerLoading />
}
